import React from "react";
import { motion } from "framer-motion";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[50vh] bg-gradient-to-r from-[#0D0D0D] via-[#1A1A1A] to-[#2B0000] overflow-hidden flex items-center justify-center px-6 md:px-12">
      {/* Background Red Glow Animation */}
      <motion.div
        className="absolute inset-0 bg-[radial-gradient(circle_at_right,_rgba(215,25,32,0.25)_0%,_transparent_70%)]"
        animate={{ opacity: [0.3, 0.6, 0.3] }}
        transition={{ duration: 6, repeat: Infinity }}
      />

      {/* Subtle diagonal gradient for depth */}
      <div className="absolute inset-0 bg-gradient-to-tr from-[#D71920]/20 via-transparent to-transparent"></div>

      {/* Animated faint light streak (adds luxury look) */}
      <motion.div
        className="absolute top-0 left-0 w-full h-full opacity-10"
        style={{
          backgroundImage:
            "linear-gradient(120deg, transparent 40%, rgba(255,255,255,0.15) 50%, transparent 60%)",
          backgroundSize: "300% 300%",
        }}
        animate={{ backgroundPosition: ["0% 0%", "100% 100%", "0% 0%"] }}
        transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* Content */}
      <div className="relative z-10 text-center max-w-3xl">
        <motion.h1
          className="text-3xl md:text-5xl font-extrabold text-white tracking-tight uppercase"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          Driven by Strength. Trusted by Generations.
        </motion.h1>

        <motion.p
          className="mt-4 text-gray-300 text-sm md:text-lg max-w-2xl mx-auto leading-relaxed"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          Since 2013, <span className="text-[#D71920] font-semibold">ISUZU Ravi Motors</span> has been at the heart of Pakistan’s transport evolution — delivering robust trucks and buses that embody Japanese engineering, durability, and long-term trust.
        </motion.p>

        <motion.div
          className="mt-6 flex justify-center gap-4"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <motion.a
            href="/showroom"
            className="bg-[#D71920] hover:bg-[#b01217] text-white font-semibold px-6 py-2.5 rounded-md text-sm md:text-base shadow-md transition-all duration-300"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Explore Models
          </motion.a>
          <motion.a
            href="/about"
            className="border border-white/70 hover:border-[#D71920] hover:text-[#D71920] text-white font-semibold px-6 py-2.5 rounded-md text-sm md:text-base transition-all duration-300"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Learn More
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
}
